import { Tag } from "antd";
import _ from "lodash";
import { useCallback } from "react";
import { AccountNumberOption } from "../components/Criteria/AccountNumberCriteriaSelect";

export const useTagRender = (optionsData: AccountNumberOption[]) => {
  const tagRender = useCallback(
    (props: any) => {
      const { value, closable, onClose } = props;

      const option = optionsData.find((data) => data.name === value);

      const isError: boolean = option?.isPending ? false : !option || _.isNaN(+option.name) || option.id === null;

      return (
        <Tag className={`mr-1 select-tag ${isError ? "error-label" : ""}`} closable={closable} onClose={onClose}>
          {value}
        </Tag>
      );
    },
    [optionsData]
  );

  return { tagRender };
};
